import React, { useState, useEffect } from "react";
import { Upload, Button } from "antd";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";

const ImageUploader = ({ selectedImage, setSelectedImage, error, setError }) => {
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        if (selectedImage && typeof selectedImage !== "string") {
            const objectUrl = URL.createObjectURL(selectedImage);
            setPreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl);
        } else if (typeof selectedImage === "string") {
            setPreview(selectedImage);
        } else {
            setPreview(null);
        }
    }, [selectedImage]);

    const handleImageChange = (file) => {
        console.log("fdxgchvjbknl ==>>", file)
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

        if (!allowedTypes.includes(file.type)) {
            setError("Only JPEG, JPG, and PNG files are allowed.");
            return false;
        }
       console.log("fdsghj ===>>", file)
        if (file.size > 50048576) {
            setError("File size should not exceed 1MB.");
            return false;
        }

               console.log("fdsghjert ===>>", file)

        setError("");
        setSelectedImage(file);
        console.log("kjhjkh ===>>", file)
        return false;
    };

    const handleRemoveImage = () => {
        setSelectedImage(null);
        setPreview(null);
    };

    return (
        <div className="mt-6">
            <div className="border-dashed border-2 border-gray-300 rounded p-4 text-center">
                <p className="text-sm text-gray-500 mb-2">Attach Image</p>
                <Upload beforeUpload={handleImageChange} showUploadList={false}>
                    <Button icon={<PlusOutlined />} className="border-none text-[#0a3021]">
                        Add Image
                    </Button>
                </Upload>
                {preview && (
                    <div className="mt-4 relative">
                        <img
                            src={preview}
                            alt="Uploaded"
                            className="w-[360px] h-60 object-contain rounded border border-gray-300"
                        />
                        <button
                            onClick={handleRemoveImage}
                            className="absolute top-0 right-0 bg-[#0a3021] px-2 py-1 rounded-full text-white text-[14px]"
                        >
                            <CloseOutlined />
                        </button>
                    </div>
                )}
            </div>
            {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    );
};

export default ImageUploader;
